import { Component } from 'react';

const rootEl =
  document.scrollingElement ||
  document.documentElement ||
  document.body.parentNode ||
  document.body;

const withInfiniteScroll = Wrapped =>
  class extends Component {
    state = {
      scroll: {
        scrollTop: 0,
        innerHeight: 0,
        offsetHeight: 0,
      },
    };

    componentDidMount() {
      this.bindScrollEvent();
      this.bindResizeEvent();

      this.setState({
        scroll: {
          ...this.state.scroll,
          innerHeight: window.innerHeight,
        },
      });
    }

    componentDidUpdate(prevProps, prevState) {
      const { scroll } = this.state;
      const { offsetHeight } = scroll;

      if (offsetHeight !== rootEl.offsetHeight) {
        this.setState({
          scroll: {
            ...this.state.scroll,
            offsetHeight: rootEl.offsetHeight,
          },
        });
      }
    }

    bindScrollEvent = () => {
      document.addEventListener('scroll', this.handleScroll);
    };

    unbindScrollEvent = () => {
      document.removeEventListener('scroll', this.handleScroll);
    };

    bindResizeEvent = () => {
      window.addEventListener('resize', this.handleResize);
    };

    unbindResizeEvent = () => {
      window.removeEventListener('resize', this.handleResize);
    };

    handleScroll = () => {
      const { scrollTop } = this.state.scroll;

      if (rootEl.scrollTop !== scrollTop) {
        this.setState({
          scroll: {
            ...this.state.scroll,
            scrollTop: rootEl.scrollTop,
          },
        });
      }
    };

    handleResize = () => {
      const { innerHeight } = this.state.scroll;

      if (window.innerHeight !== innerHeight) {
        this.setState({
          scroll: {
            ...this.state.scroll,
            innerHeight: window.innerHeight,
          },
        });
      }
    };

    componentWillUnmount() {
      this.unbindScrollEvent();
      this.unbindResizeEvent();
    }

    render() {
      return (
        <Wrapped
          checkScrollPosition={this.checkScrollPosition}
          {...this.props}
          {...this.state}
        />
      );
    }
  };

export default withInfiniteScroll;
